import React from "react";

export default function ColorFrame43({ fill, frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <g transform={frameTextToggle}>
        <rect
          width="14.429"
          height="25.853"
          fill="#350A72"
          rx="7.215"
          transform="matrix(-1 0 0 1 213.755 249.307)"
        ></rect>
        <rect
          width="14.429"
          height="25.853"
          fill="#350A72"
          rx="7.215"
          transform="matrix(-1 0 0 1 76.675 249.307)"
        ></rect>
        <rect
          width="61.926"
          height="90.184"
          x="106.736"
          y="4.006"
          stroke="#A199FF"
          strokeWidth="6.012"
          rx="14.43"
        ></rect>
        <rect
          width="61.325"
          height="14.429"
          x="106.736"
          y="1"
          fill="#350A72"
          rx="7.215"
        ></rect>
        <rect
          width="196"
          height="225.46"
          x="40"
          y="38.877"
          fill={fill}
          rx="40.883"
        ></rect>
        <rect
          width="5.411"
          height="172.552"
          x="74.871"
          y="65.331"
          fill={fill}
          opacity="0.3"
          rx="2.706"
        ></rect>
        <rect
          width="5.411"
          height="172.552"
          x="115.153"
          y="65.331"
          fill={fill}
          opacity="0.3"
          rx="2.706"
        ></rect>
        <rect
          width="5.411"
          height="172.552"
          x="155.436"
          y="65.331"
          fill={fill}
          opacity="0.3"
          rx="2.706"
        ></rect>
        <rect
          width="5.411"
          height="172.552"
          x="195.718"
          y="65.331"
          fill={fill}
          opacity="0.3"
          rx="2.706"
        ></rect>
        <rect
          width="101.607"
          height="101.607"
          x="86.895"
          y="90.803"
          fill="#fff"
          stroke="#350A72"
          strokeWidth="6.012"
          rx="9.62"
        ></rect>
        {children}
      </g>
    </svg>
  );
}
